import { TAppTypesApiSubstitutes, TAppTypesDisplaySubsitutes } from 'types/apps'

export const APP_TYPES_DISPLAY_SUBSTITUTES: Record<
  TAppTypesApiSubstitutes,
  TAppTypesDisplaySubsitutes
> = {
  menumanager: 'Menu Manager',
  availability: 'Status',
  refund: 'Orders',
  devices: 'Device Manager',
  manager: 'Suites',
  data: 'Reports Only',
  datanext: 'Reports & Exports',
  canopy: 'Dashboard',
  loyalty: 'Loyalty',
  access: 'Access',
}

export const APP_TYPES_API_SUBSTITUTES: Record<
  TAppTypesDisplaySubsitutes,
  TAppTypesApiSubstitutes
> = {
  'Menu Manager': 'menumanager',
  Status: 'availability',
  Orders: 'refund',
  'Device Manager': 'devices',
  Suites: 'manager',
  'Reports Only': 'data',
  'Reports & Exports': 'datanext',
  Dashboard: 'canopy',
  Loyalty: 'loyalty',
  Access: 'access',
}
